export const safecheckEn = {
  filter: "Filter",
  reset: "Reset",
  search: "Search",
  print: "Print",
  back: "Back",
  cancel: "Cancel",
  filters: "Search filters",
  show: "Show",
  entries: "entries",
  items: "item(s)",
  searchLabel: "Search:",
  tablePagination: {
    showing: "Showing",
    to: "to",
    of: "of",
    entries: "entries",
    previous: "Previous",
    next: "Next",
  },
  status: { active: "ACTIVE", inactive: "INACTIVE" },
  columns: { status: "STATUS", actions: "ACTIONS" },
  fields: {
    company: "COMPANY",
    province: "PROVINCE",
    branch: "BRANCH",
    systemId: "SYSTEM ID",
    status: "STATUS",
  },
  nav: {
    dashboard: "Dashboard",
    management: "MANAGEMENT",
    structure: "STRUCTURE",
    packagesSection: "PACKAGES & AGREEMENTS",
    systemSection: "SYSTEM",
    proforma: "Proforma",
    consultation: "CONSULTATION",
    authorizations: "AUTHORIZATIONS",
    configuration: "CONFIGURATION",
    reportingSection: "REPORTING",
    operations: "OPERATIONS",
    insurers: "Insurers",
    reporting: "Reporting",
    claimsControl: "Claims control",
    claimsPortfolio: "Portfolio",
    codeReferentials: "Reference data",
    actCodes: "Act codes",
    affectionCodes: "Condition codes (ICD-10)",
    claimsPackages: "Packages",
    coverage: "Coverage",
    claimsGrids: "Tariff grids",
    insurerNetwork: "Provider network",
    claimsReport: "Claims report",
    claimsSettlements: "Settlements",
    managers: "Account managers",
    deadlines: "Processing deadlines",
    users: "Users",
    allAccounts: "All accounts",
    addUser: "Add user",
    supportRequests: "Complaints and requests",
    providers: "Providers",
    allProviders: "All providers",
    addProvider: "Add provider",
    companies: "Companies",
    allCompanies: "All companies",
    addCompany: "Add company",
    employees: "Employees",
    allEmployees: "All employees",
    addEmployee: "Add employee",
    beneficiaries: "Beneficiaries",
    branches: "Branches",
    acts: "Acts & Diagnostics",
    actsOverview: "Acts & Diagnostics",
    consultActs: "Browse acts",
    consultDiagnostics: "Browse diagnostics",
    standardActCodes: "Standard codes - Acts",
    standardDiagnosticCodes: "Standard codes - Diagnostics",
    hospitalActs: "Acts by hospital",
    pharmacyCatalog: "Pharmacy catalog",
    categoryValidation: "Category validation",
    admissions: "Admissions",
    invoices: "Invoices",
    submitInvoice: "Submit an invoice",
    pendingInvoices: "Invoices awaiting audit",
    allInvoices: "All invoices",
    approvedInvoices: "Approved invoices",
    approvedInvoicesToPay: "Payment notes",
    decomptes: "Statements",
    rejectedInvoices: "Rejected invoices",
    auditedInvoices: "Audited invoices",
    statistics: "Statistics",
    globalStatistics: "Global statistics",
    packages: "Packages",
    allPackages: "All packages",
    createPackage: "Create package",
    conventions: "Agreements",
    allConventions: "All agreements",
    createConvention: "New agreement",
    budgetConsumption: "Budget consumption",
    requests: "Authorization requests",
    companyBilling: "Company billing",
    allCompanyBilling: "All statements",
    createCompanyBilling: "New statement",
    exchangeRates: "Exchange rates",
    backup: "Backup",
    createBackup: "Create backup",
    restoreBackup: "Restoration",
    systemLogs: "System logs",
    cacheManagement: "Cache management",
    settings: "Settings",
    adminDashboard: "Admin dashboard",
    auditorDashboard: "Dashboard",
    auditSection: "AUDIT",
    requestsToValidate: "Requests to validate",
    hospitalDashboard: "Dashboard",
    disputes: "Disputes",
    admissionList: "Admission list",
    newAdmission: "New admission",
    allAdmissions: "All admissions",
    allDisputes: "All disputes",
    createDispute: "Create a dispute",
    inProgressDisputes: "Disputes in progress",
    processedDisputes: "Processed disputes",
    allAuditReports: "All audit reports",
    submitAuditReport: "Submit audit report",
    auditReports: "Audit reports",
    viewInvoices: "View invoices",
    enterpriseDashboard: "Dashboard",
    generateInvoice: "Global invoice",
    employeeManagement: "Employee management",
    employeeList: "Insured members",
    beneficiaryList: "Beneficiary list",
    communication: "COMMUNICATION",
    messaging: "Messaging",
    userProfile: "User profile",
    companyProfile: "Company profile",
    providerProfile: "Provider profile",
    medicalActs: "Medical acts",
    diagnostics: "Facility diagnostics",
  },
  login: {
    platform: "Healthcare management platform",
    title: "Welcome back!",
    subtitle: "Sign in to access your workspace",
    email: "EMAIL ADDRESS",
    password: "PASSWORD",
    remember: "Remember me",
    forgotPassword: "Forgot password?",
    submit: "Sign in",
    secure: "Secure & Confidential",
    access: "24/7 Access",
    demo: "Access demo mode →",
    tagline: "Simplified management",
    backToHome: "Back to home",
  },
  startup: {
    loading: "Loading…",
    platform: "Healthcare management platform",
  },
  accountType: {
    title: "Choose your account type",
    subtitle: "Select the workspace that matches your role to access the right dashboard.",
    accountLabel: "Account type",
    placeholder: "Select an account type",
    continue: "Continue",
    selected: "Selected",
    backToLogin: "Back to login",
    types: {
      admin: {
        title: "Administrator",
        description: "Full platform management: users, providers, packages and authorizations.",
      },
      auditor: {
        title: "Audit",
        description: "Medical review of invoices and pre-authorizations, audit reports.",
      },
      hospital: {
        title: "Claims",
        description: "Entry of provider invoices, admissions and pre-authorization requests.",
      },
      enterprise: {
        title: "Insurance",
        description: "Insurer portfolio: companies, members, dependants, network and spending.",
      },
    },
  },
  dashboard: {
    welcome: "Welcome to your dashboard.",
    adminWelcome: "Hello slutala",
    auditorWelcome: "Hi elviskatuala",
    hospitalWelcome: "Medecin de nuit",
    enterpriseWelcome: "CENTRE D'EXPERTISE D'EVALUATION ET DE CERTIFICATION (CEEC)",
    stats: {
      admin: {
        allInvoices: "All invoices",
        submittedInvoices: "Submitted invoices",
        reviewInvoices: "Invoices under review",
        approvedInvoices: "Approved invoices",
        paidInvoices: "Paid invoices",
        admissions: "Admissions",
        modifyInvoices: "Invoices to modify",
        validationRequests: "Validation requests",
      },
      auditor: {
        allInvoices: "All invoices",
        submittedInvoices: "Submitted invoices",
        reviewInvoices: "Invoices under review",
        approvedInvoices: "Approved invoices",
        paidInvoices: "Paid invoices",
        modifyInvoices: "Invoices to modify",
        validationRequired: "Requests to validate",
      },
      hospital: {
        allInvoices: "All invoices",
        submittedInvoices: "Submitted invoices",
        paidInvoices: "Paid invoices",
        reviewInvoices: "Invoices under review",
        approvedInvoices: "Approved invoices",
        rejectedInvoices: "Rejected invoices",
        monthlyRevenue: "Monthly revenue",
      },
      enterprise: {
        allInvoices: "All invoices",
        approvedInvoices: "Approved invoices",
        monthlyExpenses: "Monthly expenses",
        totalAgents: "Total agents",
        todayAdmissions: "Today's admissions",
        hfInvoices: "HF invoices",
        beneficiaries: "Beneficiaries",
      },
    },
    enterpriseBoard: {
      pageTitle: "Dashboard",
      subtitle:
        "Full history · budget {budget} USD — {year} forecast · {beneficiaries} beneficiaries",
      filterDisclaimer:
        "Invoices filtered by billing period (invoice start date); admissions by admission date; headcount as of filter end date. Amounts = client billed (after refraction).",
      filters: {
        from: "FROM",
        to: "TO",
        hospital: "HOSPITAL",
        apply: "Filter",
        fullHistory: "FULL HISTORY",
        allHospitals: "All hospitals",
      },
      sections: {
        synthesis: "SUMMARY",
        invoicesAdmissions: "INVOICES & ADMISSIONS",
        quickAccess: "QUICK ACCESS",
        statistics: "STATISTICS",
      },
      quickAccess: {
        admissions: "Admissions",
        invoices: "Invoices",
        agents: "Agents",
        beneficiaries: "Beneficiaries",
      },
      visitDistribution: {
        title: "Visit distribution (Top 5)",
        viewAll: "View all",
        agents: "Agents",
        spouses: "Spouses",
        children: "Children",
      },
      pathologies: {
        title: "Frequent pathologies (Top 5)",
        viewAll: "View all",
      },
      careTypes: {
        title: "Distribution by care type (Top 6)",
        subtitle: "Out-of-package · approved / paid invoices",
        viewAll: "View all",
        columns: {
          type: "TYPE",
          quantity: "QUANTITY",
          price: "PRICE",
        },
        rows: {
          pharmacy: "Pharmacy",
          nursing: "Nursing",
          imaging: "Imaging",
          laboratory: "Laboratory",
          imagingLab: "Imaging, lab and diagnostics",
          consultation: "Consultation (general, specialist)",
          surgery: "Surgery",
          rehabilitation: "Support and rehabilitation",
        },
      },
      agePyramid: {
        title: "Age pyramid",
        subtitle: "Headcount - date of birth",
        viewAll: "View all",
      },
      budget: {
        title: "Budget",
        allocated: "Allocated budget",
        annualForecast: "2026 annual forecast",
        periodRange: "From {start} to {end}",
        cumulative: "Cumulative consumption",
        cumulativeOn: "As of {date}",
        outOfPackage: "Out-of-package consumption",
        outOfPackageOn: "As of {date}",
      },
      averageConsumption: {
        title: "Average consumption",
        subtitle: "Attendance and average amounts",
        attendanceRate: "Average attendance",
        amountPerAdmission: "Per admission",
        amountPerAgent: "Per agent",
        admittedAgents: "Admitted agents",
      },
      workforce: {
        title: "Workforce",
        subtitle: "Beneficiary list",
        total: "Total",
        agents: "Agents",
        spouses: "Spouses",
        children: "Children",
      },
      attendance: {
        title: "Attendance",
        subtitle: "Admitted at least once",
        total: "Total",
        agents: "Agents",
        spouses: "Spouses",
        children: "Children",
      },
      metrics: {
        admissions: "Admissions",
        allInvoices: "All invoices",
        outOfPackageInvoices: "Out-of-package invoices",
        inProgress: "In progress",
        validated: "Validated invoices",
        savings: "Savings generated",
        savingsRequested: "Requested",
        savingsValidated: "Validated",
        savingsGap: "Difference",
        dailyAttendance: "Daily attendance",
      },
    },
    enterpriseAnalytics: {
      visits: {
        title: "Visit distribution",
        subtitleFallback: "Full history",
        back: "Back to dashboard",
        loading: "Loading…",
        empty: "No admissions in this period.",
        beneficiary: "Beneficiary",
        visits: "Visits",
      },
      agePyramid: {
        title: "Age pyramid — detail",
        subtitleFallback: "Full history",
        back: "Back to dashboard",
        loading: "Loading…",
        empty: "No beneficiaries found.",
        summary:
          "Headcount as of {date} · {withBirthdate} beneficiary(ies) with birth date · {withoutBirthdate} without valid birth date",
        columns: {
          beneficiary: "Beneficiary",
          type: "Type",
          employee: "Linked employee",
          birthdate: "Birth date",
          age: "Age",
          bucket: "Range",
        },
      },
    },
    enterpriseAlerts: {
      invoiceValidated: {
        title: "Invoice validated",
        message:
          "Invoice #12 (Medecin de nuit) has been validated and is available under Approved (to pay).",
      },
      budgetCumulative: {
        title: "Budget alert",
        message:
          "Cumulative consumption has reached 59.5% of the 2026 annual budget ($424,594 / $713,400).",
      },
      budgetOutOfPackage: {
        title: "Out-of-package budget alert",
        message:
          "Out-of-package consumption is at 12.2% ($86,724). Monitor uncovered expenses.",
      },
    },
    hospitalBoard: {
      pageTitle: "Dashboard",
      subtitle: "{invoices} invoices · {revenue} monthly revenue",
      sections: {
        indicators: "Key indicators",
        quickAccess: "Quick access",
        charts: "Analytics",
        clients: "Invoices & clients",
      },
      indicators: {
        invoices: "All invoices",
        submitted: "Submitted invoices",
        paid: "Paid invoices",
        review: "Under review",
        approved: "Approved invoices",
        rejected: "Rejected invoices",
        revenue: "Monthly revenue",
      },
      indicatorFooters: {
        cumulative: "Cumulative total",
        pending: "Pending",
        settled: "$ Settled",
        inProgress: "In progress",
        validated: "Validated",
        toFix: "To fix",
        thisMonth: "This month",
      },
      quickActions: {
        control: "Control",
        settlements: "Settlements",
        invoices: "Invoices",
        portfolio: "Portfolio",
      },
      invoiceDistribution: {
        title: "Invoice distribution",
        labels: {
          submitted: "Submitted",
          review: "Under review",
          approved: "Approved",
          paid: "Paid",
          rejected: "Rejected",
        },
      },
      financials: {
        title: "Financial indicators",
        totalBilled: "Total billed amount",
        paid: "Paid amount",
        pending: "Pending amount",
        validationRate: "Validation rate",
      },
      topClients: {
        title: "Top 5 client companies",
        columns: {
          company: "COMPANY",
          invoices: "INVOICES",
          totalAmount: "TOTAL AMOUNT",
        },
      },
      filters: {
        search: "SEARCH",
        searchPlaceholder: "Search by ID, company...",
        company: "COMPANY",
        allCompanies: "All companies",
        from: "FROM",
        to: "TO",
        reset: "Reset",
      },
      submittedInvoices: {
        title: "Submitted invoices (last 100)",
        show: "Show",
        entries: "entries",
        search: "Search:",
        urgent: "URGENT",
        submitted: "SUBMITTED",
        download: "Download invoice",
        view: "View invoice",
        previous: "Previous",
        next: "Next",
        pagination: "Showing {from} to {to} of {total} entries",
        columns: {
          id: "ID",
          company: "COMPANY",
          amount: "AMOUNT",
          submittedDate: "SUBMISSION DATE",
          delay: "DELAY",
          priority: "PRIORITY",
          status: "STATUS",
          invoice: "INVOICE",
          actions: "ACTIONS",
        },
      },
    },
    auditorBoard: {
      pageTitle: "Dashboard",
      subtitle: "{invoices} invoices to audit · {requests} pending requests",
      sections: {
        indicators: "Key indicators",
        quickAccess: "Quick access",
        charts: "Analytics",
        invoices: "Submitted invoices",
      },
      indicators: {
        invoices: "All invoices",
        submitted: "Submitted invoices",
        review: "Under review",
        approved: "Approved invoices",
        paid: "Paid invoices",
        rejected: "Rejected invoices",
        validation: "Requests to validate",
      },
      indicatorFooters: {
        cumulative: "Cumulative total",
        pending: "Pending",
        settled: "$ Settled",
        inProgress: "In progress",
        validated: "Validated",
        toFix: "To fix",
      },
      quickActions: {
        toAudit: "To audit",
        approved: "Approved",
        rejected: "Rejected",
        admissions: "Admissions",
      },
      invoiceDistribution: {
        title: "Invoice distribution",
        labels: {
          submitted: "Submitted",
          review: "Under review",
          approved: "Approved",
          paid: "Paid",
          modify: "To modify",
        },
      },
      productivity: {
        title: "Productivity indicators",
        auditedToday: "Invoices audited today",
        avgAuditTime: "Average audit time",
        pendingOver48h: "Invoices pending +48h",
      },
      filters: {
        search: "Search",
        searchPlaceholder: "Search by ID, hospital, company...",
        hospital: "Hospital",
        allHospitals: "All hospitals",
        company: "Company",
        allCompanies: "All companies",
        from: "From",
        to: "To",
        reset: "Reset",
      },
      submittedInvoices: {
        title: "Submitted invoices (last 100)",
        show: "Show",
        entries: "entries",
        search: "Search:",
        urgent: "URGENT",
        normal: "NORMAL",
        submitted: "SUBMITTED",
        previous: "Previous",
        next: "Next",
        pagination: "Showing {from} to {to} of {total} entries",
        columns: {
          id: "ID",
          hospital: "HOSPITAL",
          company: "COMPANY",
          amount: "AMOUNT",
          submittedDate: "SUBMISSION DATE",
          delay: "DELAY",
          priority: "PRIORITY",
          status: "STATUS",
        },
      },
    },
  },
  adminDashboard: {
    pageTitle: "Dashboard",
    summary: "{invoices} invoices entered",
    badge: "Administration",
    sections: {
      quickAccess: "Quick access",
      charts: "Analytics",
      activity: "Activity & platform",
      invoices: "Submitted invoices",
    },
    keyIndicators: "Key indicators",
    admissionsTrend: "Admissions trend",
    admissionsLabel: "Admissions",
    invoiceOverview: "Invoice status",
    requestsOverview: "Authorization requests",
    totalRequests: "total requests",
    platformMetrics: "Platform overview",
    recentActivity: "Recent activity",
    ago: "ago",
    invoiceStatus: {
      submitted: "Submitted",
      review: "Under review",
      approved: "Approved",
      paid: "Paid",
      modify: "To modify",
    },
    requestStatus: {
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
    },
    metrics: {
      providers: "Providers",
      employees: "Employees",
      beneficiaries: "Beneficiaries",
      packages: "Active packages",
    },
    activities: {
      admission: "New admission registered",
      invoice: "Invoice submitted for review",
      request: "Authorization request received",
      employee: "New employee added",
      package: "Package updated",
    },
    indicators: {
      totalInvoices: "Total invoices",
      inReview: "Under review",
      approved: "Approved",
      admissions: "Today's admissions",
    },
    indicatorFooters: {
      cumulative: "Cumulative 2026",
      toProcess: "To process",
      validated: "Validated",
      inProgress: "{count} in progress",
      today: "Today",
    },
    quickLinks: {
      invoices: "Enter an invoice",
      admissions: "Insurers",
      users: "Users",
      providers: "Providers",
      conventions: "Validation requests",
      logs: "All invoices",
    },
    invoiceDistribution: {
      title: "Invoice distribution",
      labels: {
        submitted: "Submitted",
        review: "Under review",
        approved: "Approved",
        paid: "Paid",
        modify: "To modify",
      },
    },
    monthlyVolume: {
      title: "Monthly volume (last 6 months)",
    },
    systemStats: {
      title: "System statistics",
      labels: {
        hospitals: "Active hospitals",
        companies: "Active companies",
        auditors: "Active auditors",
        validationRate: "Validation rate",
      },
    },
    submittedInvoices: {
      title: "Submitted invoices (last 100)",
      show: "Show",
      entries: "entries",
      search: "Search:",
      urgent: "URGENT",
      submitted: "SUBMITTED",
      download: "Download invoice",
      previous: "Previous",
      next: "Next",
      pagination: "Showing {from} to {to} of {total} entries",
      columns: {
        id: "ID",
        hospital: "HOSPITAL",
        company: "COMPANY",
        amount: "AMOUNT",
        submittedDate: "SUBMISSION DATE",
        delay: "DELAY",
        priority: "PRIORITY",
        status: "STATUS",
        invoice: "INVOICE",
      },
    },
  },
  employees: {
    title: "Employee list",
    add: "Add employee",
    columns: {
      photo: "PHOTO",
      name: "NAME",
      systemId: "SYSTEM ID",
      matricule: "COMPANY ID",
      company: "COMPANY",
      province: "PROVINCE",
      branch: "BRANCH",
      status: "STATUS",
    },
    create: {
      title: "Add employee",
      backToList: "Back to list",
      cardTitle: "Register an employee",
      submit: "Create employee",
      fields: {
        fullName: "FULL NAME",
        companyMatricule: "COMPANY ID",
        birthDate: "BIRTH DATE",
        gender: "GENDER",
        company: "COMPANY",
        assignedHospital: "ASSIGNED HOSPITAL",
        position: "POSITION",
        phone: "PHONE",
        email: "EMAIL",
        city: "CITY",
        province: "PROVINCE",
      },
      placeholders: {
        fullName: "Ex: Jean Dupont",
        companyMatricule: "Internal ID",
        birthDate: "dd/mm/yyyy",
        gender: "--Select--",
        company: "--Select --",
        assignedHospital: "--None--",
        position: "--Select --",
        phone: "+243 XXX XXX XXX",
        email: "email@example.com",
        city: "Kinshasa",
        province: "--Select --",
      },
    },
    enterpriseList: {
      empty: "No employees found",
      columns: {
        photo: "Photo",
        name: "Name",
        systemId: "System ID",
        matricule: "Company ID",
        branch: "Branch",
        province: "Province",
        status: "Status",
      },
      statuses: {
        active: "ACTIVE",
        inactive: "INACTIVE",
      },
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
    },
  },
  branchesPage: {
    pageTitle: "Branch Management",
    listTitle: "Branch List",
    newBranch: "New Branch",
    search: "SEARCH",
    searchPlaceholder: "Name, province...",
    allStatuses: "All statuses",
    columns: {
      name: "BRANCH NAME",
      province: "PROVINCE",
      phone: "PHONE",
      email: "EMAIL",
      status: "STATUS",
      actions: "ACTIONS",
    },
    actions: {
      edit: "Edit",
      deactivate: "Deactivate",
      delete: "Delete",
    },
    create: {
      title: "Create Branch",
      cardTitle: "New Branch",
      submit: "Save",
      fields: {
        name: "BRANCH NAME",
        province: "PROVINCE",
        address: "ADDRESS",
        phone: "PHONE",
        email: "EMAIL",
        status: "STATUS",
      },
      placeholders: {
        name: "Ex: Kinshasa Centre",
        province: "-- Select --",
        address: "Full branch address",
        phone: "Ex: +243 XX XXX XXXX",
        email: "email@example.com",
      },
    },
  },
  usersPage: {
    title: "Users",
    addUser: "Add user",
    exportCsv: "Export CSV",
    create: {
      formTitle: "New user account",
      backToList: "Back to list",
      roleHint: "Defines user permissions",
      passwordHint: "Minimum 6 characters",
      chooseFile: "Choose file",
      noFileSelected: "No file selected",
      fileHint: "Accepted format: JPG, PNG, GIF (Max 2MB)",
      submit: "Create user",
      fields: {
        username: "USERNAME",
        email: "EMAIL",
        role: "ROLE",
        password: "PASSWORD",
        profilePhoto: "PROFILE PHOTO",
      },
      placeholders: {
        username: "Ex: Jean Dupont",
        email: "email@example.com",
        role: "-- Select a role --",
        password: "Minimum 6 characters",
      },
    },
    filters: {
      role: "ROLE",
      username: "USERNAME",
      email: "EMAIL",
      allRoles: "All roles",
      usernamePlaceholder: "Search a name...",
      emailPlaceholder: "Search an email...",
    },
    table: {
      searchPlaceholder: "Search in table...",
      columns: {
        id: "ID",
        name: "NAME",
        email: "EMAIL",
        role: "ROLE",
        photo: "PHOTO",
        actions: "ACTIONS",
      },
    },
    roles: {
      admin: "Admin (Full access)",
      auditor: "Audit (Medical advisor)",
      enterprise: "Insurance (Insurer)",
      hospital: "Claims (Claims handling)",
    },
  },
  providers: {
    title: "Care providers",
    listTitle: "Provider list",
    add: "New provider",
    columns: { name: "COMMERCIAL NAME", type: "TYPE", city: "CITY", contact: "CONTACT" },
    fields: { type: "PROVIDER TYPE", city: "CITY", cityPlaceholder: "Filter by city..." },
    create: {
      title: "Create Provider",
      backToList: "Back to list",
      cardTitle: "Provider Information",
      baseInfo: "Basic Information",
      locationInfo: "Location",
      contactInfo: "Contact Information",
      contactPersonInfo: "Contact Person",
      administrativeInfo: "Administrative Information",
      specialtiesHint: "Separate specialties with commas",
      submit: "Create provider",
      fields: {
        commercialName: "COMMERCIAL NAME",
        providerType: "PROVIDER TYPE",
        description: "DESCRIPTION",
        address: "ADDRESS",
        city: "CITY",
        province: "PROVINCE",
        postalCode: "POSTAL CODE",
        phone: "PHONE",
        email: "EMAIL",
        website: "WEBSITE",
        contactName: "FULL NAME",
        contactPhone: "PHONE NUMBER",
        contactEmail: "EMAIL ADDRESS",
        agreementNumber: "LICENSE NUMBER",
        rccm: "RCCM",
        idNat: "NATIONAL ID",
        specialties: "SPECIALTIES",
        status: "STATUS",
      },
      placeholders: {
        commercialName: "Ex: Faubourg Clinic",
        providerType: "-- Select --",
        description: "Briefly describe the provider...",
        address: "Full address...",
        city: "Ex: Kinshasa",
        province: "Ex: Kinshasa",
        postalCode: "Ex: 12345",
        phone: "+243 XX XXX XXXX",
        email: "contact@provider.com",
        website: "https://www.provider.com",
        contactName: "Ex: Jean Dupont",
        contactPhone: "+243 XX XXX XXXX",
        contactEmail: "jean.dupont@provider.com",
        agreementNumber: "Ex: AGR-2025-001",
        rccm: "Ex: RC-KIN/2025/12345",
        idNat: "Ex: 1-234-N56789K",
        specialties: "Ex: Cardiology, Pediatrics, Surgery (comma-separated)",
      },
    },
  },
  beneficiaries: {
    title: "Beneficiary list",
    columns: {
      photo: "PHOTO",
      name: "NAME",
      relation: "RELATION",
      birthDate: "DATE OF BIRTH",
      gender: "GENDER",
      employee: "EMPLOYEE",
      matricule: "ID",
    },
    fields: {
      relation: "RELATION",
      allRelations: "All relations",
      gender: "GENDER",
      allGenders: "All",
      birthDate: "DATE OF BIRTH",
      ageMin: "MINIMUM AGE",
      ageMax: "MAXIMUM AGE",
    },
    enterpriseList: {
      searchPlaceholder: "Search...",
      exportCsv: "Export CSV",
      backToEmployees: "Employee list",
      empty: "No beneficiaries found",
      columns: {
        photo: "Photo",
        name: "Name",
        relation: "Relation",
        systemId: "System ID",
        companyMatricule: "Company ID",
        company: "Company",
      },
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
    },
  },
  admissions: {
    title: "Admissions",
    listTitle: "Admission list",
    create: {
      pageTitle: "Create a new admission",
      backToList: "Back to list",
      instructions:
        "How to use: Enter or scan the patient's SYSTEM ID (e.g. SFC0002), then select the patient to admit (employee or dependent).",
      step1Title: "Step 1: Patient identification",
      step2Title: "Step 2: Date and reason",
      systemIdLabel: "SYSTEM ID (REGISTRATION)",
      systemIdPlaceholder: "E.g. SFC0002",
      systemIdHint: "Enter the registration number or scan the patient card QR code",
      search: "Search",
      scanQrLabel: "SCAN QR CODE",
      scanQrButton: "Scan QR Code",
      noResults: "No patient found for this ID.",
      selectPatient: "Select the patient to admit:",
      scanUnavailable: "QR scanning will be available on this device soon.",
      dateLabel: "Admission date",
      motifLabel: "Reason (optional)",
      motifPlaceholder: "E.g. Consultation, emergency…",
      submit: "Create admission",
    },
    exportCsv: "Export CSV",
    searchPlaceholder: "Search...",
    columns: {
      date: "Admission date",
      patient: "Patient",
      type: "Type",
      hospital: "Hospital",
      company: "Company",
      status: "Status",
      actions: "Actions",
    },
    fields: {
      dateFrom: "From",
      dateFromHint: "Includes this day and later",
      dateTo: "Until",
      dateToHint: "Includes this day (leave empty = no end)",
      status: "Status",
      patientType: "Patient type",
      hospital: "Hospital",
      company: "Company",
      allStatuses: "All statuses",
      allTypes: "All types",
      allHospitals: "All hospitals",
      allCompanies: "All companies",
    },
    patientTypes: {
      employee: "EMPLOYEE",
      beneficiary: "DEPENDENT",
    },
    statuses: {
      inProgress: "IN PROGRESS",
      completed: "COMPLETED",
      cancelled: "CANCELLED",
    },
    empty: "No admissions found",
    pagination: {
      showing: "Showing",
      to: "to",
      of: "of",
      entries: "entries",
      previous: "Previous",
      next: "Next",
    },
    enterpriseList: {
      pageTitle: "Admissions (Enterprise)",
      searchPlaceholder: "Search...",
      exportCsv: "Export CSV",
      empty: "No admissions found",
      defaultMotif: "SafeCheck admission",
      patientTypes: {
        employee: "Employee",
        beneficiary: "Dependent",
      },
      columns: {
        date: "Admission date",
        patient: "Patient",
        type: "Type",
        hospital: "Hospital",
        status: "Status",
        reason: "Reason",
        actions: "Actions",
      },
      actions: {
        view: "View",
      },
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
    },
    hospitalList: {
      pageTitle: "Admissions (Hospital)",
      searchPlaceholder: "Search...",
      exportCsv: "Export CSV",
      empty: "No admissions found",
      patientTypes: {
        employee: "Employee",
        beneficiary: "Dependent",
      },
      columns: {
        date: "Admission date",
        patient: "Patient",
        type: "Type",
        company: "Company",
        status: "Status",
        actions: "Actions",
      },
      actions: {
        view: "View",
      },
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
    },
  },
  messaging: {
    pageTitle: "Messaging",
    subtitles: {
      enterprise:
        "Communicate exclusively with the SafeCheck team (platform administration).",
      hospital:
        "Communicate with the SafeCheck team and auditors.",
      admin:
        "Communicate with all platform accounts.",
      auditor:
        "Communicate with healthcare providers.",
    },
    searchPlaceholder: "Search a conversation...",
    emptyList: "No conversations found",
    filters: {
      all: "All",
      unread: "Unread",
    },
    chat: {
      online: "Online",
      offline: "Offline",
      placeholder: "Write your message...",
      send: "Send",
      backToList: "Back to conversations",
      today: "Today",
      yesterday: "Yesterday",
      selectConversation: "Select a conversation to view messages.",
    },
    floating: {
      minimize: "Minimize to floating window",
      maximize: "Open full messaging",
      collapse: "Collapse window",
      expand: "Expand conversation",
      close: "Close floating window",
      openInbox: "Open messaging",
    },
  },
  settingsPage: {
    userProfile: {
      pageTitle: "User profile",
      badge: "ENTERPRISE",
      contactTitle: "Contact information",
      tabs: {
        information: "Information",
        security: "Security",
      },
      sections: {
        userAccount: "User account",
        companyInfo: "Company information",
        profilePhoto: "Profile photo",
        security: "Security",
      },
      fields: {
        username: "Username",
        email: "Email",
        companyName: "Company name",
        address: "Address",
        phone: "Phone",
        profilePhoto: "Change photo (optional)",
        currentPassword: "Current password",
        newPassword: "New password",
        confirmPassword: "Confirm password",
      },
      photoHint: "Accepted format: JPG, PNG. Max size: 2MB",
      chooseFile: "Choose file",
      noFileSelected: "No file chosen",
      save: "Save changes",
      reset: "Reset",
      updatePassword: "Update password",
      hospital: {
        badge: "PROVIDER",
        sections: {
          providerInfo: "Provider information",
        },
        fields: {
          providerName: "Provider name",
        },
      },
    },
    companyProfile: {
      pageTitle: "Company profile",
      sectionTitle: "Company information",
      fields: {
        companyName: "Company name",
        address: "Address",
        phone: "Phone",
      },
      save: "Save",
    },
    providerProfile: {
      pageTitle: "Provider profile",
      sectionTitle: "Provider information",
      fields: {
        providerName: "Provider name",
        address: "Address",
        phone: "Phone",
      },
      save: "Save",
    },
  },
  packages: {
    title: "Packages",
    listTitle: "Package list",
    add: "New package",
    searchPlaceholder: "Search...",
    exportCsv: "Export CSV",
    empty: "No packages found",
    included: "INCLUDED",
    excluded: "EXCLUDED",
    columns: { code: "CODE", name: "NAME", hospital: "HOSPITAL", rate: "MONTHLY RATE", period: "PERIOD", acts: "ACTS" },
    fields: {
      allStatuses: "All statuses",
      allHospitals: "All hospitals",
      allCompanies: "All companies",
      status: "STATUS",
      hospital: "HOSPITAL",
      company: "COMPANY",
    },
    summary: { total: "Total packages", active: "Active", draft: "Drafts", suspended: "Suspended" },
    pagination: {
      showing: "Showing",
      to: "to",
      of: "of",
      entries: "entries",
      previous: "Previous",
      next: "Next",
    },
    create: {
      title: "Create package",
      editTitle: "Edit package",
      backToList: "Back to list",
      cancel: "Cancel",
      back: "Back",
      previous: "Previous",
      nextActs: "Next: Select acts",
      nextValidation: "Next: Validation",
      submit: "Create package",
      editSubmit: "Save changes",
      generalInfo: "General information",
      requiredField: "Please fill in this field",
      steps: {
        information: "Information",
        includedActs: "Included acts",
        validation: "Validation",
      },
      fields: {
        hospital: "HOSPITAL",
        company: "COMPANY",
        name: "PACKAGE NAME",
        monthlyRate: "MONTHLY RATE (USD)",
        periodStart: "START DATE",
        periodEnd: "END DATE",
        description: "DESCRIPTION",
        status: "STATUS",
      },
      placeholders: {
        hospital: "-- Select a hospital --",
        company: "-- Select a company --",
        name: "E.g. Standard package 2026",
        monthlyRate: "150000",
        periodStart: "dd/mm/yyyy",
        periodEnd: "dd/mm/yyyy",
        description: "General package description...",
      },
      statuses: {
        draft: "Draft (activate later)",
        active: "Active",
        suspended: "Suspended",
      },
      includedActs: {
        title: "Select included acts",
        instructions:
          "Instructions: Check the acts that are INCLUDED in the package. Unchecked acts will require prior authorization (out of package).",
        available: "Available acts",
        included: "Included acts",
        outOfPackage: "Out of package",
        searchPlaceholder: "Search for an act...",
        selectAll: "Select all",
        deselectAll: "Deselect all",
        selectedCount: "{selected} act(s) selected out of {total}",
        emptyHospital: "No acts found for this hospital.",
        limits: {
          toggle: "Limits (quantity / period / notes)",
          quantity: "Max quantity",
          quantityPlaceholder: "E.g. 5",
          period: "Period",
          periodNone: "—",
          perDay: "per day",
          perWeek: "per week",
          perMonth: "per month",
          perYear: "per year",
          notes: "Notes",
          notesPlaceholder: "Notes…",
        },
      },
      validation: {
        title: "Validation and creation",
        readyMessage: "Your package is ready to be created. Review the information below.",
        summary: "Summary",
        statistics: "Statistics:",
        periodSeparator: "->",
        statusDraft: "DRAFT (ACTIVATE LATER)",
        includedActsBadge: "{count} INCLUDED ACTS (PACKAGE)",
        outOfPackageBadge: "{count} OUT-OF-PACKAGE ACTS",
        importantNotice:
          "Important: Once the package is created and activated, it will be used automatically to verify proforma requests.",
        fields: {
          hospital: "Hospital",
          company: "Company",
          packageName: "Package name",
          monthlyRate: "Monthly rate",
          period: "Period",
          status: "Status",
        },
      },
    },
  },
  conventions: {
    title: "Agreements",
    add: "New agreement",
    listTitle: "Agreements",
    empty: "No agreements found.",
    providersBadge: "{count} PROVIDER(S)",
    validitySeparator: "->",
    summary: {
      total: "Total",
      active: "Active",
      expiringSoon: "Expiring soon",
      budgetAlerts: "Budget alerts",
    },
    fields: {
      status: "STATUS",
      company: "COMPANY",
      provider: "PROVIDER",
      allStatuses: "All statuses",
      allCompanies: "All companies",
      allProviders: "All providers",
    },
    columns: {
      code: "CODE",
      convention: "AGREEMENT",
      company: "COMPANY",
      providers: "PROVIDERS",
      type: "TYPE",
      validity: "VALIDITY",
      budget: "BUDGET",
      consumption: "CONSUMPTION",
      status: "STATUS",
      actions: "ACTIONS",
    },
    types: {
      forfaitaire: "PACKAGE",
      tiers_payant: "THIRD-PARTY PAYMENT",
      remboursement: "REIMBURSEMENT",
      mixte: "MIXED",
      a_la_facture: "THIRD-PARTY PAYMENT",
    },
    statuses: {
      active: "ACTIVE",
      expiring: "EXPIRING SOON",
      expired: "EXPIRED",
      draft: "DRAFT",
      suspended: "SUSPENDED",
      cancelled: "CANCELLED",
    },
    view: {
      edit: "Edit",
      backToList: "Back to list",
      generalInfo: "General information",
      budgetConsumption: "Budget & consumption",
      financialParams: "Financial parameters",
      beneficiaryRules: "Dependent rules",
      code: "Agreement code",
      company: "Company",
      providers: "Covered providers",
      noProviders: "No associated providers",
      treatmentType: "Treatment type",
      validity: "Validity period",
      description: "Description",
      specialConditions: "Special conditions",
      budgetTotal: "Total budget",
      monthlyForfait: "Monthly package",
      consumed: "Consumed",
      remaining: "Remaining",
      consumptionRate: "Consumption rate",
      consumptionRateForfait: "Consumption rate (current month)",
      alertThreshold: "Alert threshold",
      perFamily: "/ family",
      globalForfait: "global package",
      providerRates: "{count} provider rate(s)",
      maxChildAge: "Max child age",
      maxStudentAge: "Max student age",
      maxSpouseAge: "Max spouse age",
      maxDependents: "Max dependents",
      coveredTypes: "Covered types",
      noLimit: "No limit",
      years: "years",
      alertWarning: "Warning: budget reached the {threshold}% alert threshold.",
      budgetDepleted: "Budget depleted or monthly package exceeded.",
      invoicesTitle: "Invoices included in consumption",
      invoicesPeriod: "Period {start} → {end}",
      invoicesCount: "{count} invoice(s)",
      invoicesEmpty: "No invoices counted for the current period.",
      viewInvoice: "View",
      invoiceColumns: {
        reference: "Reference",
        provider: "Provider",
        period: "Period",
        nature: "Type",
        status: "Status",
        amount: "Amount USD",
        actions: "Actions",
        total: "Total consumed",
      },
    },
    create: {
      title: "New agreement",
      editTitle: "Edit agreement",
      back: "Back",
      backToList: "Back to list",
      generalInfo: "General information",
      contractingParties: "Contracting parties",
      financialParams: "Financial parameters",
      personCeilingsTitle: "Per-person ceilings",
      familyCeilingsTitle: "Family (household) ceilings",
      beneficiaryRules: "Beneficiary rules",
      providerForfaitSection: "Provider package rates (USD / family / month)",
      cancel: "Cancel",
      submit: "Save agreement",
      requiredField: "This field is required.",
      optional: "OPTIONAL",
      fields: {
        title: "AGREEMENT TITLE",
        treatmentType: "TREATMENT TYPE",
        coverageUnit: "BUDGET COVERAGE UNIT",
        startDate: "START DATE",
        endDate: "END DATE",
        description: "DESCRIPTION",
        specialConditions: "SPECIAL CONDITIONS",
        company: "COMPANY",
        coveredProviders: "COVERED PROVIDERS",
        coveredProvidersHint: "(MULTIPLE SELECTION)",
        providerForfait: "PROVIDER PACKAGE",
        providerClientForfait: "CLIENT BILLED PACKAGE",
        totalBudget: "TOTAL BUDGET (USD)",
        budgetPeriodicity: "BUDGET PERIODICITY",
        individualCeiling: "INDIVIDUAL CEILING (USD)",
        dailyCeiling: "DAILY CEILING (USD)",
        monthlyCeiling: "MONTHLY CEILING (USD)",
        annualCeiling: "ANNUAL CEILING (USD)",
        familyDailyCeiling: "HOUSEHOLD DAILY CEILING (USD)",
        familyMonthlyCeiling: "HOUSEHOLD MONTHLY CEILING (USD)",
        familyAnnualCeiling: "HOUSEHOLD ANNUAL CEILING (USD)",
        monthlyPackageAmount: "MONTHLY PACKAGE AMOUNT (USD) IF PACKAGE",
        copayPct: "COPAY (%)",
        globalBudgetAlertThreshold: "GLOBAL BUDGET ALERT THRESHOLD (%)",
        individualAlertThreshold: "INDIVIDUAL ALERT THRESHOLD (%)",
        childAgeLimit: "CHILD AGE LIMIT",
        studentChildAgeLimit: "STUDENT CHILD AGE LIMIT",
        spouseAgeLimit: "SPOUSE AGE LIMIT",
        maxDependentsPerEmployee: "MAX DEPENDENTS / EMPLOYEE",
        coveredDependentTypes: "COVERED DEPENDENT TYPES",
      },
      placeholders: {
        title: "E.g. XYZ Company Health Agreement 2026",
        treatmentType: "--Choose--",
        date: "dd/mm/yyyy",
        description: "Describe the purpose and scope of this agreement...",
        specialConditions: "Special clauses, exclusions, etc.",
        company: "--Select a company--",
        globalBudgetAlertThreshold: "80",
        individualAlertThreshold: "e.g. 80",
        childAgeLimit: "21",
        studentChildAgeLimit: "26",
        spouseAgeLimit: "No limit",
        maxDependentsPerEmployee: "5",
      },
      hints: {
        coveredProviders: "Hold Ctrl (Windows) or ⌘ (Mac) to select multiple providers.",
        providerForfaits:
          "Leave blank to use the global package or the hospital-linked package.",
        globalBudgetAlert: "Alert when the global budget reaches this threshold",
        individualAlert: "Alert when an employee reaches this % of their individual ceiling",
        coverageUnit: "Whether ceilings apply per person, per family, or both.",
        budgetPeriodicity: "Renewal period for the global budget envelope (calendar).",
        personCeilings: "Counters for each beneficiary. Daily ≤ monthly ≤ annual.",
        familyCeilings: "One shared pot for employee + dependents. Daily ≤ monthly ≤ annual.",
      },
      suffixes: {
        years: "yrs",
        percent: "%",
      },
      dependentTypes: {
        spouse: "Spouse",
        children: "Children",
        parents: "Parents",
        other: "Other",
      },
      coverageUnits: {
        personne: "Per person",
        famille: "Per family",
        mixte: "Mixed (person + family)",
      },
      coverageUnitHints: {
        personne: "Each beneficiary has their own ceilings.",
        famille: "Employee + dependents share the same household ceilings.",
        mixte: "Both apply: the most restrictive one blocks.",
      },
      budgetPeriodicities: {
        trimestriel: "Quarterly",
        semestriel: "Semi-annual",
        annuel: "Annual",
      },
      budgetPeriodicityHints: {
        trimestriel: "Envelope renews each calendar quarter (Q1–Q4).",
        semestriel: "Envelope renews each calendar half-year (H1–H2).",
        annuel: "Envelope renews each calendar year.",
      },
      treatmentTypes: {
        forfaitaire: "PACKAGE",
        tiers_payant: "THIRD-PARTY PAYMENT",
        remboursement: "REIMBURSEMENT",
        mixte: "MIXED",
        a_la_facture: "THIRD-PARTY PAYMENT",
      },
    },
  },
  budgetConsumption: {
    title: "Budget consumption",
    subtitle:
      "Budget set per period (quarterly / semi-annual / annual) vs sum of monthly package + out-of-package invoices.",
    backToConventions: "Back to agreements",
    filters: "Filters",
    company: "Company",
    allCompanies: "All companies",
    periodicity: "Periodicity (view)",
    period: "Period",
    refresh: "Refresh",
    hint: "Each agreement keeps its own periodicity; the filter only changes which period keys are listed.",
    tableTitle: "Consumption ({count})",
    loading: "Loading…",
    empty: "No data for this selection.",
    columns: {
      company: "Company",
      convention: "Agreement",
      period: "Period",
      budget: "Period budget",
      forfait: "Monthly package",
      horsForfait: "Out of package",
      consumed: "Total consumed",
      pct: "%",
      status: "Status",
      actions: "Actions",
    },
    status: {
      ok: "OK",
      alert: "Alert",
      depleted: "Exceeded",
    },
    editBudget: "Edit period budget",
    saveBudget: "Save",
    cancelEdit: "Cancel",
    editSaved: "Period budget saved.",
    editError: "Could not save.",
    editInvalid: "Invalid amount.",
    openRevision: "Revise",
    revisionTitle: "Budget revision",
    revisionTab: "New revision",
    historyTab: "History",
    natureLabel: "Envelope",
    effectiveFrom: "Effective date (e.g. province opening)",
    suggestEffectif: "Calculate from headcount",
    suggestLoading: "Calculating…",
    effectifBefore: "Headcount before",
    effectifAfter: "Headcount after",
    suggestedDelta: "Suggested adjustment",
    newBudget: "New budget",
    newAmountLabel: "Period budget amount (USD)",
    reasonLabel: "Reason / comment",
    reasonPlaceholder: "E.g. Kinshasa extension — +120 families since January",
    saveRevision: "Save revision",
    saving: "Saving…",
    revisionSaved: "Budget revision saved.",
    historyEmpty: "No revisions for this period.",
  },
  requests: {
    title: "Authorization requests",
    add: "New request",
    listTitle: "Request list",
    filtersTitle: "Filters",
    searchPlaceholder: "Search...",
    exportCsv: "Export CSV",
    empty: "No requests found.",
    urgency: { normal: "NORMAL", urgent: "URGENT", emergency: "Critical emergency" },
    status: { pending: "PENDING", approved: "APPROVED", rejected: "REJECTED" },
    createForm: {
      systemIdSearch: "Search by system ID (optional)",
      systemIdPlaceholder: "System ID (e.g. SFC0171)",
      systemIdRequired: "Enter a system ID.",
      patientType: "Patient",
      patientEmployee: "Main employee",
      patientDependent: "Dependent",
      dependentName: "Dependent",
      dependentPlaceholder: "Select a dependent",
      noDependents: "No dependents registered for this employee.",
      loadingDependents: "Loading dependents…",
      actsTitle: "Requested acts",
      actsHint: "Add acts from the hospital tariff grid.",
      addAct: "Add act",
      actSearch: "Search act (code or label)",
      noActs: "No acts added.",
      selectHospitalFirst: "Select a hospital first to load acts.",
      quantity: "Qty",
      unitPrice: "Unit price (USD)",
      lineTotal: "Total",
      estimatedAmount: "Estimated total (USD)",
      estimatedHint: "Automatically calculated from added acts.",
      urgencyLevel: "Urgency level",
      actsRequired: "Add at least one act to the request.",
      dependentRequired: "Select the dependent from the list.",
    },
    columns: {
      id: "ID",
      patient: "PATIENT",
      package: "PACKAGE",
      hospital: "HOSPITAL",
      company: "COMPANY",
      urgency: "URGENCY",
      date: "DATE",
    },
    fields: {
      status: "STATUS",
      allStatuses: "All",
      allUrgencies: "All",
      urgency: "URGENCY",
    },
    summary: {
      total: "Total",
      totalSub: "Total requests",
      pending: "Pending",
      pendingSub: "To process",
      approved: "Approved",
      approvedSub: "Validated",
      rejected: "Rejected",
      rejectedSub: "Refused",
    },
    pagination: {
      showing: "Showing",
      to: "to",
      of: "of",
      entries: "entries",
      previous: "Previous",
      next: "Next",
    },
  },
  acts: {
    overview: {
      title: "Acts & Diagnostics",
      subtitle:
        "Browse standardized act and diagnostic reference catalogs used for analysis and statistics.",
      actsCard: {
        title: "Browse acts",
        description: "Browse the standard medical acts catalog.",
        countLabel: "{count} standard acts",
        link: "Go to acts",
      },
      diagnosticsCard: {
        title: "Browse diagnostics",
        description: "Browse the standard diagnostics catalog.",
        countLabel: "{count} standard diagnostics",
        link: "Go to diagnostics",
      },
    },
    standardCodes: {
      title: "Standard medical acts",
      add: "Add standard act",
      infoBanner:
        "Information: These standard codes allow auditors to group detailed hospital acts into standardized categories to facilitate global analysis and statistics.",
      exportCsv: "Export CSV",
      searchPlaceholder: "Search...",
      deleteConfirm: "Delete this standard act?",
      empty: "No standard acts found",
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
      columns: {
        code: "Code",
        name: "Name",
        category: "Category",
        specialty: "Specialty",
        description: "Description",
        actions: "Actions",
      },
      create: {
        title: "Add standard act",
        cardTitle: "New standard act",
        submit: "Save",
        categoryPlaceholder: "-- Select --",
        fields: {
          code: "CODE",
          name: "NAME",
          category: "CATEGORY",
          specialty: "SPECIALTY",
          description: "DESCRIPTION",
        },
        placeholders: {
          code: "Ex: COR30",
          name: "Ex: CODE REFRACTION CONSULTATION",
          specialty: "Specialty (optional)",
          description: "Detailed description (optional)",
        },
      },
      edit: {
        title: "Edit standard act",
        cardTitle: "Edit standard act",
        submit: "Save",
        notFound: "Standard act not found.",
        categoryPlaceholder: "-- Select --",
        fields: {
          code: "CODE",
          name: "NAME",
          category: "CATEGORY",
          specialty: "SPECIALTY",
          description: "DESCRIPTION",
        },
        placeholders: {
          code: "Ex: COR30",
          name: "Ex: CODE REFRACTION CONSULTATION",
          specialty: "Specialty (optional)",
          description: "Detailed description (optional)",
        },
      },
    },
    standardDiagnostics: {
      title: "Standard diagnostics",
      add: "Add standard diagnostic",
      infoBanner:
        "Information: These standard codes allow auditors to associate a standardized diagnosis with invoices to facilitate global analysis and statistics.",
      exportCsv: "Export CSV",
      searchPlaceholder: "Search...",
      deleteConfirm: "Delete this standard diagnostic?",
      empty: "No standard diagnostics found",
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
      columns: {
        code: "Code",
        name: "Name",
        type: "Type",
        description: "Description",
        actions: "Actions",
      },
      create: {
        title: "Add standard diagnostic",
        cardTitle: "New standard diagnostic",
        submit: "Save",
        typePlaceholder: "-- Select --",
        fields: {
          code: "CODE",
          name: "NAME",
          type: "TYPE",
          description: "DESCRIPTION",
        },
        placeholders: {
          code: "Ex: 11",
          name: "Ex: CARDIAC ARRHYTHMIA",
          description: "Detailed description (optional)",
        },
      },
      edit: {
        title: "Edit standard diagnostic",
        cardTitle: "Edit standard diagnostic",
        submit: "Save",
        notFound: "Standard diagnostic not found.",
        typePlaceholder: "-- Select --",
        fields: {
          code: "CODE",
          name: "NAME",
          type: "TYPE",
          description: "DESCRIPTION",
        },
        placeholders: {
          code: "Ex: 11",
          name: "Ex: CARDIAC ARRHYTHMIA",
          description: "Detailed description (optional)",
        },
      },
    },
    hospitalActs: {
      title: "Medical acts by hospital",
      infoBanner:
        "Information: This table displays the medical acts that each hospital has configured in its fee schedule. These acts serve as a reference for auditors.",
      exportCsv: "Export CSV",
      searchPlaceholder: "Search...",
      noActsConfigured: "No acts configured",
      actsCount: "{count} ACT(S)",
      view: "View",
      pagination: "Showing {from} to {to} of {total} entries",
      previous: "Previous",
      next: "Next",
      filters: {
        actsLabel: "Filter by acts",
        all: "All hospitals",
        withActs: "With configured acts",
        withoutActs: "Without configured acts",
      },
      actions: {
        validateCategories: "Validate categories",
        aiAllGrids: "AI (all grids)",
        reclassifyAi: "Reclassify (AI)",
      },
      columns: {
        hospital: "Hospital",
        actCount: "Number of acts",
        actions: "Actions",
      },
      modal: {
        title: "Medical acts - {hospital}",
        close: "Close",
        columns: {
          code: "Code",
          label: "Label",
          careType: "Care type",
          cost: "Cost (USD)",
          delay: "Delay (d)",
        },
        careTypes: {
          nursing: "Nursing",
          consultation: "Consultation (general, specialized)",
          surgery: "Surgery",
        imaging: "Imaging",
        laboratory: "Laboratory",
        imagingLab: "Imaging, lab and diagnostic",
        },
      },
    },
    medicalActs: {
      pageTitle: "Medical Acts Management",
      import: {
        title: "CSV/Excel import",
        fileLabel: "CSV FILE",
        chooseFile: "Choose file",
        noFileSelected: "No file chosen",
        formatHint: "Format: code, libelle, cout (with headers)",
        submit: "Import",
        downloadExample: "Download CSV example",
        duplicateHint: "Duplicate codes will be ignored",
        selectFileFirst: "Please select a CSV file.",
        success: "Import simulated successfully.",
      },
      create: {
        title: "Create a medical act",
        submit: "Create",
        validationError: "Please fill in all required fields.",
        duplicateCode: "This code already exists.",
        success: "Medical act created.",
        fields: {
          code: "CODE",
          label: "LABEL",
          cost: "COST (USD)",
        },
        placeholders: {
          code: "Ex: CONS001",
          label: "Ex: General consultation",
          cost: "Ex: 50.00",
        },
      },
      list: {
        title: "My medical acts",
        pendingBadge: "{count} TO VALIDATE",
        ai: "AI (~{count})",
        delete: "Delete",
        deleteSuccess: "Act deleted.",
        searchPlaceholder: "Code or label...",
        pagination: "Showing {from} to {to} of {total} entries",
        previous: "Previous",
        next: "Next",
        columns: {
          label: "LABEL",
          careType: "CARE TYPE",
          cost: "COST",
          createdAt: "CREATED ON",
          action: "ACTION",
        },
      },
      careTypes: {
        pharmacy: "Pharmacy",
        nursing: "Nursing",
        consultation: "Consultation",
        surgery: "Surgery",
        imaging: "Imaging",
        laboratory: "Laboratory",
        imagingLab: "Imaging, lab and diagnostic",
      },
    },
    categoryValidation: {
      title: "Category validation",
      exportCsv: "Export CSV",
      applyFilter: "Filter",
      allHospitals: "All",
      allCategories: "All",
      fields: {
        hospital: "HOSPITAL",
        filter: "FILTER",
        currentCategory: "CURRENT CATEGORY",
        search: "SEARCH",
      },
      searchPlaceholder: "Code or label...",
      summary: {
        toValidate: "To validate",
        classified: "Classified (reliable)",
        manuallyValidated: "Manually validated",
        lowConfidence: "Low confidence",
        unclassified: "Unclassified",
      },
      filterStatus: {
        toValidate: "To validate",
        classified: "Classified (reliable)",
        manuallyValidated: "Manually validated",
        lowConfidence: "Low confidence",
        unclassified: "Unclassified",
      },
      approve: "Approve",
      reject: "Reject",
      processed: "Processed",
      results: {
        title: "Results",
        hint: "Select a hospital to validate in bulk.",
        ok: "OK",
        confidenceSource: {
          rule: "rule",
          ai: "ai",
        },
        columns: {
          hospital: "Hospital",
          code: "Code",
          label: "Label",
          proposedCategory: "Proposed category",
          confidence: "Confidence",
          actions: "Actions",
        },
      },
    },
  },
  statistics: {
    dashboardButton: "Dashboard",
    pageTitle: "Analytical dashboard",
    summary: "{admissions} admissions • {invoiced} USD invoiced • {companies} companies • {hospitals} hospitals — Year {year}",
    badge: "Administration",
    auditBadge: "Audit",
    keyIndicators: "Key indicators",
    indicators: {
      admissions: "Admissions 2026",
      invoicedAmount: "Invoiced amount",
      avgCost: "Avg. cost / invoice",
      companies: "Active companies",
      hospitals: "Hospitals",
      employees: "Active employees",
    },
    indicatorFooters: {
      thisYear: "This year",
      usdYear: "USD 2026",
      usd: "USD",
      active: "Active",
      partners: "Partners",
      activeEmployees: "Active",
    },
    trends: {
      sectionTitle: "Trends and distributions",
      monthlyAdmissions: "Monthly admissions",
      monthlyInvoiced: "Monthly invoiced amounts",
      admissionStatuses: "Admission statuses",
      invoiceStatuses: "Invoice statuses 2026",
      topMedicalActs: "Top 5 medical acts",
      last12Months: "Last 12 months",
      months12: "12 months",
      byFrequency2026: "By frequency 2026",
      admissionStatusLabels: {
        pending: "Pending",
        inProgress: "In progress",
        completed: "Completed",
        transferred: "Transferred",
      },
      invoiceStatusLabels: {
        submitted: "Submitted",
        underReview: "Under Review",
        approved: "Approved",
      },
    },
    insights: {
      frequentDiagnostics: "Frequent diagnostics",
      companyExpenses: "Expenses by company",
      topHospitals: "Top hospitals {year}",
      top8: "Top 8",
      year2026: "2026",
      admissionsCount: "{count} adm.",
      emptyTopHospitals: "No admissions for this year",
    },
    charts: "Charts",
    diseaseTitle: "Frequent Disease Types",
    legend: "Disease frequency",
  },
  system: {
    backup: {
      description: "Manage platform backups and schedule data exports.",
      createDescription: "Create a full or partial backup of the platform.",
      restoreDescription: "Restore data from an existing backup.",
      exportInstruction: "Export a database backup in SQL format.",
      exportButton: "Export backup",
      exportSuccess: "SQL backup exported successfully.",
      importInstruction: "Import a .sql file exported from backup.",
      chooseFile: "Choose a file",
      noFileSelected: "No file chosen",
      importButton: "Import",
      importSuccess: "Backup imported successfully.",
      importInvalidFile: "Please select a valid .sql file.",
    },
    logs: {
      description: "Browse system event history and activity logs.",
      breadcrumb: "Logs",
      historyTitle: "Action history",
      columns: {
        id: "ID",
        date: "DATE",
        user: "USER",
        action: "ACTION",
      },
    },
    cache: {
      description: "Clear and optimize application cache to improve performance.",
      clearAll: "Clear all cache",
      clearAllSuccess: "Cache cleared successfully.",
      cleanExpiredSuccess: "Expired entries removed.",
      clearOpcacheSuccess: "PHP OPcache cleared.",
      disableCacheSuccess: "Cache disabled.",
      stats: {
        totalEntries: "Total Entries",
        validEntries: "Valid Entries",
        expiredEntries: "Expired Entries",
        totalSize: "Total Size",
        usagePercent: "{percent} used",
      },
      spaceUsage: {
        title: "Space usage",
      },
      quickActions: {
        title: "Quick Actions",
        cleanExpired: "Clean expired entries",
        clearOpcache: "Clear PHP OPcache",
        disableCache: "Disable cache",
      },
      entries: {
        title: "Cache Entries",
        columns: {
          key: "KEY",
          size: "SIZE",
          created: "CREATED",
          expires: "EXPIRES",
          ttl: "TTL",
          status: "STATUS",
          actions: "ACTIONS",
        },
        expired: "EXPIRED",
        deleteSuccess: "Cache entry deleted.",
        empty: "No cache entries.",
      },
    },
  },
  disputes: {
    title: "Disputes",
    create: "Create dispute",
    newTitle: "New dispute",
    submit: "Create dispute",
    listPlaceholder: "All disputes list coming soon.",
    processedPlaceholder: "Processed disputes list coming soon.",
    createForm: {
      backToList: "Back to list",
      back: "Back",
      infoBanner:
        "Information: The dispute will be created with a \"Pending\" status and can be processed by an auditor.",
    },
    list: {
      pageTitle: "All disputes",
      createButton: "Create dispute",
      searchPlaceholder: "Search...",
      exportCsv: "Export CSV",
      allStatuses: "All statuses",
      empty: "No disputes found",
      emptyRegistered: "No disputes registered yet.",
      statuses: {
        inProgress: "In progress",
        resolved: "Resolved",
        rejected: "Rejected",
        closed: "Closed",
      },
      columns: {
        id: "ID",
        date: "Date",
        hospital: "Hospital",
        company: "Company",
        nature: "Nature",
        amount: "Amount",
        status: "Status",
        actions: "Actions",
      },
      actions: {
        view: "View",
      },
    },
    inProgress: {
      cardTitle: "Disputes requiring processing",
      emptySuccess: "No disputes pending. All disputes have been processed.",
      viewAll: "View all disputes",
    },
    fields: {
      invoice: "CONCERNED INVOICE",
      invoicePlaceholder: "-- Select an invoice --",
      invoiceHint: "Select the invoice concerned by this dispute.",
      description: "DISPUTE DESCRIPTION",
      descriptionPlaceholder: "Describe the problem in detail...",
      descriptionHelpIntro: "Provide a detailed description including:",
      descriptionHelpBullets: {
        problem: "The exact problem identified",
        amounts: "The amounts or acts concerned",
        documents: "Reference documents",
        other: "Any relevant information",
      },
    },
  },
  auditReports: {
    list: {
      title: "Audit reports",
      subtitle: "All registered audit reports",
      submitButton: "Submit a report",
      searchPlaceholder: "Search…",
      reset: "Reset",
      exportCsv: "Export CSV",
      loading: "Loading…",
      empty: "No audit reports available.",
      view: "View report",
      columns: {
        id: "ID",
        auditDate: "Audit date",
        invoice: "Invoice #",
        hospital: "Hospital",
        company: "Company",
        auditor: "Auditor",
        originalAmount: "Original amount",
        basketTotal: "Basket total",
        status: "Status",
        actions: "Actions",
      },
    },
    detail: {
      title: "Audit report",
      loading: "Loading report…",
      notFound: "Report not found.",
      loadError: "Unable to load report.",
      backToList: "Back to list",
      viewInvoice: "View invoice",
      print: "Print",
      auditDate: "Audit date",
      invoice: "Invoice #",
      status: "Status",
      auditor: "Auditor",
      hospital: "Hospital",
      company: "Company",
      financialAnalysis: "Financial analysis",
      originalAmount: "Original amount",
      basketTotal: "Basket total",
      difference: "Difference",
      note: "Note",
      basketTitle: "Selected acts detail",
      basketCode: "Code",
      basketLabel: "Label",
      basketCost: "Cost (USD)",
      total: "Total",
      diagnosis: "Diagnosis",
      reportContent: "Audit report",
      noReportContent: "No report content.",
    },
    submit: {
      title: "Submit an audit report",
      subtitle: "Write the report associated with an audited invoice.",
      backToList: "Back to list",
      invoiceId: "Invoice ID",
      invoiceIdPlaceholder: "e.g. 42",
      report: "Report",
      reportPlaceholder: "Enter the audit report content…",
      submit: "Submit report",
      saving: "Saving…",
      validationError: "Invoice and report are required.",
      saveError: "Unable to save report.",
      successMessage: "Report submitted successfully.",
    },
  },
  invoices: {
    billing: "Billing",
    globalTitle: "Global invoice generation",
    filtersTitle: "Generation filters",
    filtersSubtitle: "Select criteria to generate your global invoice",
    selectCompany: "Select a company",
    month: "MONTH",
    year: "YEAR",
    dateRange: "Date range (alternative to month/year)",
    startDate: "START DATE",
    startDateHint: "Select the start date of the period",
    endDate: "END DATE",
    endDateHint: "Select the end date of the period",
    systemId: "SYS ID (MATRICULE)",
    systemIdHint: "Enter system ID to filter by specific patient",
    provider: "PROVIDER",
    allProviders: "All providers",
    actType: "MEDICAL ACT TYPE",
    generate: "Generate global invoice",
    submit: {
      title: "Submit an invoice",
      cardTitle: "New invoice",
      steps: {
        provider: "Provider & Company",
        amounts: "Amounts",
        summary: "Summary",
      },
      next: "Next",
      previous: "Previous",
      submit: "Submit invoice",
      success: "Your invoice was submitted successfully. It will appear in pending invoices.",
      viewPending: "View pending invoices",
      summaryTitle: "Verify before submitting",
      statusBannerPrefix: "The invoice will be submitted with status",
      statusBannerStatus: "Pending audit.",
      fields: {
        provider: "Provider",
        providerPlaceholder: "— Select a provider —",
        company: "Company",
        companyPlaceholder: "— Select a company —",
        periodFrom: "Period from",
        periodTo: "To",
        datePlaceholder: "dd/mm/yyyy",
        providerReference: "Provider invoice ref.",
        providerReferencePlaceholder: "E.g. 2602-104239",
        attachment: "Invoice file (PDF / JPG / PNG)",
        attachmentHint: "Required (package and out-of-package). Max 20 MB.",
        chooseFile: "Choose a file",
        noFileSelected: "No file chosen",
        totalAmount: "Total invoice amount",
        totalAmountHint: "Gross amount appearing on the provider's invoice.",
        rsspAmount: "RSSP amount",
        rsspAmountHint: "Portion paid to the national fund (leave blank if none).",
        currency: "Invoice currency",
        currencyHint: "Act comparison will use this currency.",
        currencyUsd: "USD ($) — dollars",
        currencyCdf: "CDF (FC) — Congolese francs",
        exchangeRate: "FC → USD rate",
        exchangeRateHint: "Hospital default rate (editable if needed).",
        notes: "Notes (optional)",
        notesPlaceholder: "Remarks on this invoice...",
        amountsBannerTitle: "Out-of-package invoice",
        amountsBannerText:
          "— Acts not covered by the package. Enter the actual amount appearing on the provider's invoice.",
      },
      summary: {
        provider: "Provider",
        company: "Company",
        convention: "Agreement",
        treatmentMode: "Treatment mode",
        invoiceNature: "Invoice type",
        period: "Period",
        reference: "Provider ref.",
        currency: "Currency",
        exchangeRate: "FC/USD rate",
        invoiceAmount: "Invoice amount",
        rsspPortion: "of which RSSP",
        amountToPay: "Amount to pay",
        file: "File",
        notes: "Notes",
        noConvention: "No agreement",
        outOfPackage: "Out of package",
      },
    },
    pendingAudit: {
      title: "Invoices awaiting audit",
      submitInvoice: "Submit an invoice",
      searchPlaceholder: "Search...",
      exportExcel: "Export Excel",
      exportPdf: "Export PDF",
      download: "Download",
      empty: "No pending invoices",
      statuses: {
        awaitingClaims: "AWAITING CLAIMS",
        inReview: "UNDER REVIEW",
        submitted: "SUBMITTED",
        pendingAudit: "PENDING AUDIT",
      },
      columns: {
        id: "ID",
        provider: "Provider / Hospital",
        company: "Company",
        nature: "Nature",
        invoice: "Invoice",
        status: "Status",
        createdAt: "Created at",
        actions: "Actions",
      },
      filters: {
        hospital: "Hospital",
        company: "Company",
        status: "Status",
        allHospitals: "All",
        allCompanies: "All",
        allStatuses: "Pending (all)",
      },
    },
    all: {
      title: "Invoices",
      searchPlaceholder: "Search...",
      exportExcel: "Export Excel",
      exportPdf: "Export PDF",
      download: "Download",
      empty: "No invoices found",
      allStatuses: "All statuses",
      statuses: {
        awaitingClaims: "AWAITING CLAIMS",
        inReview: "UNDER REVIEW",
        submitted: "SUBMITTED",
        pendingAudit: "PENDING AUDIT",
        approved: "VALIDATED",
        rejected: "REJECTED",
      },
      columns: {
        id: "ID",
        date: "Date",
        hospital: "Hospital",
        company: "Company",
        nature: "Nature",
        amount: "Amount",
        status: "Status",
        actions: "Actions",
      },
      actions: {
        view: "View",
        edit: "Edit",
      },
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
    },
    enterpriseAll: {
      searchPlaceholder: "Search...",
      exportCsv: "Export CSV",
      download: "Download",
      empty: "No billing statement published by administration.",
      allStatuses: "All statuses",
      statuses: {
        submitted: "SUBMITTED",
        awaitingClaims: "AWAITING CLAIMS",
        inReview: "UNDER REVIEW",
        approved: "VALIDATED",
        rejected: "REJECTED",
      },
      columns: {
        id: "ID",
        hospital: "Hospital",
        company: "Company",
        nature: "Nature",
        invoice: "Invoice",
        status: "Status",
        actions: "Actions",
      },
      actions: {
        view: "View",
      },
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
    },
    hospitalView: {
      searchPlaceholder: "Search...",
      exportCsv: "Export CSV",
      download: "Download",
      empty: "No invoices found",
      allStatuses: "All statuses",
      statuses: {
        submitted: "SUBMITTED",
        awaitingClaims: "AWAITING CLAIMS",
        inReview: "UNDER REVIEW",
        approved: "VALIDATED",
      },
      columns: {
        id: "ID",
        company: "Company",
        nature: "Nature",
        invoice: "Invoice",
        status: "Status",
        actions: "Actions",
      },
      actions: {
        view: "View",
      },
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
    },
    enterpriseDetail: {
      pageTitle: "Invoice #{id}",
      billingPageTitle: "Statement #{id}",
      notFound: "Invoice not found.",
      billingNotFound: "Statement not found.",
      download: "Download",
      print: "Print",
      back: "Back",
      sections: {
        info: "Invoice information",
        acts: "Medical acts",
        document: "Invoice document",
        billingDocuments: "Statement attachments",
        tracking: "Tracking",
      },
      fields: {
        patientEmployee: "Patient (Employee)",
        company: "Company",
        hospital: "Provider / Hospital",
        treatmentType: "Treatment type",
        invoiceNature: "Invoice nature",
        providerReference: "Provider reference",
        period: "Period",
        submissionNotes: "Submission notes",
        number: "Number",
        submittedAt: "Submitted on",
        totalAmount: "Total billed amount",
        coveredAmount: "Covered amount",
        coveredAmountHint: "Amount covered / approved for the client (after refraction)",
        currentStatus: "Current status",
      },
      treatmentTypes: {
        forfaitaire: "PACKAGE",
        standard: "STANDARD",
      },
      invoiceNatures: {
        forfait_mensuel: "MONTHLY PACKAGE",
        hors_forfait: "OUT OF PACKAGE",
      },
      glossary: {
        status:
          "Workflow status: SUBMITTED (filed), UNDER REVIEW (audit), APPROVED or REJECTED.",
        treatment:
          "Convention treatment type: STANDARD (fee-for-service) or PACKAGE (forfait).",
        nature: "Invoice nature (when set): MONTHLY PACKAGE or OUT OF PACKAGE.",
      },
      actColumns: ["CODE", "LABEL", "COST", "DATE"],
      emptyActs: "No acts recorded",
      emptyActsForfait: "Acts billed under the package (forfait)",
      totalBilled: "TOTAL BILLED",
      documentHint: "Preview of the invoice attachment",
      noAttachments: "No attachments on this statement.",
      billingPreviewHint: "Preview available for attached PDFs and images.",
      billingCompanyNotice:
        "Safecheck statement for your company. Internal provider documents are not shown.",
    },
    enterpriseApproved: {
      download: "Download",
      empty: "No published billing statement to pay.",
      status: "APPROVED",
      columns: {
        id: "ID",
        hospital: "Hospital",
        company: "Company",
        nature: "Nature",
        invoice: "Invoice",
        status: "Status",
        actions: "Actions",
      },
      actions: {
        view: "View",
      },
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
    },
    approved: {
      title: "Approved invoices",
      searchPlaceholder: "Search...",
      exportCsv: "Export CSV",
      empty: "No approved invoices.",
      status: "APPROVED",
      columns: {
        id: "ID",
        date: "Date",
        hospital: "Hospital",
        company: "Company",
        nature: "Nature",
        amount: "Amount",
        status: "Status",
        actions: "Actions",
      },
      actions: {
        view: "View",
      },
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
    },
    rejected: {
      title: "Rejected invoices",
      searchPlaceholder: "Search...",
      exportCsv: "Export CSV",
      empty: "No rejected invoices",
      status: "REJECTED",
      columns: {
        id: "ID",
        date: "Date",
        hospital: "Hospital",
        company: "Company",
        nature: "Nature",
        amount: "Amount",
        status: "Status",
        actions: "Actions",
      },
      actions: {
        view: "View",
      },
    },
    audited: {
      title: "Audited invoices",
      searchPlaceholder: "Search...",
      allStatuses: "All statuses",
      download: "Download",
      empty: "No audited invoices.",
      statusApproved: "APPROVED",
      statusRejected: "REJECTED",
      actsDiagnostics: "Acts & Diagnostics",
      columns: {
        id: "ID",
        hospital: "Hospital",
        company: "Company",
        nature: "Nature",
        invoice: "Invoice",
        status: "Status",
        actions: "Actions",
      },
      actions: {
        view: "View",
        edit: "Edit",
      },
      pagination: {
        showing: "Showing",
        to: "to",
        of: "of",
        entries: "entries",
        previous: "Previous",
        next: "Next",
      },
    },
    list: {
      searchPlaceholder: "Search...",
      exportCsv: "Export CSV",
      view: "View invoice",
      empty: "No invoices found",
      statuses: {
        pending: "PENDING",
        approved: "APPROVED",
        rejected: "REJECTED",
      },
      variants: {
        all: {
          title: "All invoices",
          subtitle: "Complete view of all platform invoices.",
        },
        pending: {
          title: "Pending invoices",
          subtitle: "Submitted invoices awaiting review or validation.",
        },
        approved: {
          title: "Approved invoices",
          subtitle: "Invoices validated by auditors.",
        },
        rejected: {
          title: "Rejected invoices",
          subtitle: "Rejected invoices requiring correction.",
        },
      },
      columns: {
        reference: "Reference",
        hospital: "Hospital",
        company: "Company",
        amount: "Amount",
        period: "Period",
        submittedDate: "Submission date",
        delay: "Delay",
        status: "Status",
        actions: "Actions",
      },
      fields: {
        dateFrom: "From",
        dateFromHint: "Includes this day and later",
        dateTo: "Until",
        dateToHint: "Includes this day (leave empty = no end)",
        hospital: "Hospital",
        company: "Company",
        allHospitals: "All hospitals",
        allCompanies: "All companies",
      },
    },
  },
} as const;

export type SafecheckNavKey = keyof typeof safecheckEn.nav;
